<template>
  <div class="empty-state">
    <v-icon :icon="icon" size="48" class="empty-state__icon" />
    <p class="empty-state__title">{{ title }}</p>
    <p v-if="description" class="empty-state__desc">{{ description }}</p>
    <div v-if="$slots.action" class="empty-state__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: { type: String, required: true },
    description: { type: String, default: "" },
    icon: { type: String, default: "mdi-inbox-outline" },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 64px var(--space-4);
  color: var(--text-tertiary);
}

.empty-state__icon {
  color: var(--text-disabled);
  margin-bottom: var(--space-3);
}

.empty-state__title {
  margin: 0 0 var(--space-1);
  font-size: var(--font-body-strong-size);
  line-height: var(--font-body-strong-line);
  font-weight: var(--font-body-strong-weight);
  color: var(--text-secondary);
}

.empty-state__desc {
  margin: 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.empty-state__action {
  margin-top: var(--space-4);
}
</style>
